import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { FocusMonitor } from '@angular/cdk/a11y';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router'
import { HttpService } from 'src/app/http.service';
import * as moment from 'moment';
import * as AWS from "aws-sdk";
import { SeoSocialShareService } from 'ngx-seo';
declare var jQuery:any;

function ValidateEmail(control: AbstractControl): { [key: string]: Boolean } | null {

  // let regularExp = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|yahoo|outlook)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
  let regularExp = /^([\w.-]+)@((?!hotmail|gmail|yahoo|outlook)([a-zA-Z\d-]+\.)+)([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;

  if (control.value !== undefined && !regularExp.test(control.value)) {
    return { "isValidEmail": true };
  }
  return null;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  @ViewChild('closebutton') closebutton: any;
  // form: FormGroup;
  submittedSub = false;
  subscribeForm: FormGroup;
  demoSubmitted = false;
  demoForm: FormGroup;
  public message: any;
  cilentIPAddress = '';
  pdfPath: any;
  currentRoutePath: any;
  routerpath:string='';
  currentRouterLink: string = '';
  constructor(public fb: FormBuilder, private http: HttpClient, public router: Router, private httpService: HttpService,private seoService: SeoSocialShareService) {
    this.currentRoutePath = this.router.url;
    router.events.subscribe((data:Event) =>{
      if(data instanceof NavigationEnd){
        this.routerpath = data.url.split('?')[0];
        // console.log('routePath', this.routerpath);
        // var that = this;
        // setTimeout(() => {
        //   var title = jQuery("meta[name='title']")[0].content || '';
        //   var description = jQuery("meta[name='description']")[0].content || '';
        //   var img_url = jQuery('.og_image_url').length > 0 ? jQuery('.og_image_url')[0].src : (environment.og_base_url+'/assets/images/logo/cropped-logo-2.png');
        //   that.seoService.setTitle(title);
        //   that.seoService.setDescription(description);
        //   that.seoService.setUrl(environment.og_base_url + that.routerpath);
        //   that.seoService.setImage(img_url);
        // }, 100);
      }
    });
    this.httpService.getIPAddress().subscribe((res: any) => {
      this.cilentIPAddress = res.ip;
    });

    this.subscribeForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
    });
    this.demoForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
      name: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern('^[A-Za-z ]+$')])],
      designation: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      message: [''],
      contactnumber: ['', Validators.compose([Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")])],
      company_name: ['', Validators.compose([Validators.required])],
      time_slot1: ['', Validators.compose([Validators.required])],
      time_slot2: ['', Validators.compose([Validators.required])],
    });

  }

  API_URL = environment.API_URL;
  public send_email(httpService: HttpService) {
    httpService
      .sendPostRequest('abc@abc.com')
      .subscribe((responseBody: any) => {
      });
  }
  get getSubForm() {
    return this.subscribeForm.controls;
  }

  get getDemoForm() {
    return this.demoForm.controls;
  }
  // submitForm1() {
  //   const headerDict = {
  //     'Content-Type': 'application/json',
  //     Accept: 'application/json',
  //     'Access-Control-Allow-Headers': '*',
  //   };
  //   const requestOptions = {
  //     headers: new HttpHeaders(headerDict),
  //   };
  //   var formData: any = new FormData();

  //   formData.append('email', this.demoForm.get('email')!.value);
  //   if (this.demoForm.get('email')!.value.length == 0) {
  //     alert('Please Enter Email Address');
  //     return;
  //   }
  //   if (
  //     this.demoForm.get('time_slot1')!.value.length == 0 ||
  //     this.demoForm.get('time_slot2')!.value.length == 0
  //   ) {
  //     alert('Please Enter both Time Slots');
  //     return;
  //   }
  //   if (this.demoForm.get('name')!.value.length == 0) {
  //     alert('Please Enter Name');
  //     return;
  //   }
  //   var email = JSON.stringify({
  //     email: this.demoForm.get('email')!.value,
  //     name: this.demoForm.get('name')!.value,
  //     business_email: this.demoForm.get('business_email')!.value,
  //     company_name: this.demoForm.get('company_name')!.value,
  //     designation: this.demoForm.get('designation')!.value,
  //     time_slot1: this.demoForm.get('time_slot1')!.value,
  //     time_slot2: this.demoForm.get('time_slot2')!.value,
  //   }); 
  //   this.http.post(this.API_URL1, email, requestOptions).subscribe(
  //     (response: any) => {
  //       this.message = response.message;
  //     },
  //   );
  //   alert('Your Query has been submitted Successfully');
  // }
  onReset() {

    this.message = '';
    this.demoForm.reset();
    this.subscribeForm.reset();
    this.demoSubmitted = false;
    this.submittedSub = false;
  }
  subRespData: any;

  onReset1() {

    this.message = '';
    this.demoForm.reset();
    this.subscribeForm.reset();
    this.demoSubmitted = false;
    this.submittedSub = false;
  }

  submitSubForm() {
    let url = environment.API_URL + "subscribe";
    // let url = "https://dev.website.protectt.ai/Webapi/email/subscribe";
    let urlValue = "";
    this.submittedSub = true;
    if (this.subscribeForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      let subData = {
        email: this.subscribeForm.value['email'],
        ipaddress: this.cilentIPAddress,
        weburl: urlValue
      }
      let data = {
        subscriptionData: subData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }


      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          this.subRespData = JSON.parse(decMsg);
        },
        error => {
        });

    }
  }

  submitDemoForm1() {
    let dateString1 = this.demoForm.get('time_slot1')!.value;
    let dateString2 = this.demoForm.get('time_slot2')!.value;
    var dateTimeSlot1 = moment(dateString1).format('DD-MM-YYYY HH:MM');
    var dateTimeSlot2 = moment(dateString2).format('DD-MM-YYYY HH:MM');
    let url = environment.API_URL + "requestdemo";
    let urlValue = "";
    this.demoSubmitted = true;
    if (this.demoForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      var demoData = {
        email: this.demoForm.get('email')!.value,
        name: this.demoForm.get('name')!.value,
        designation: this.demoForm.get('designation')!.value,
        message: this.demoForm.get('message')!.value,
        contactnumber: this.demoForm.get('contactnumber')!.value,
        companyname: this.demoForm.get('company_name')!.value,
        timeslot1: dateTimeSlot1,
        timeslot2: dateTimeSlot2,
        ipaddress: this.cilentIPAddress,
        weburl: urlValue,
        adcampurl: this.currentRoutePath
      };
      let data = {
        salesLeadData: demoData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }

      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          let resp: any = JSON.parse(decMsg);
          alert(resp['statusDesc']);
          // this.subRespData = JSON.parse(decMsg);
        },
        error => {
        });


      this.demoSubmitted = false;
      // alert("Request has been submitted..");
      this.closebutton.nativeElement.click();
    }
  }
  s3: any;
  ngOnInit(): void {
    
  }
  onClickPdfView(filename: any) {
    // console.log(filename)
    let AKey;
    let SKey;
    let url = environment.API_URL + "fetchbucketcred"
    this.httpService.getAPI(url).then((resp: any) => {
      // console.log(resp);
      let decRes = this.httpService.decryptText(resp, HttpService.SECRET_KEY);
      let decMsg = JSON.parse(decRes);
      // console.log(decMsg?.lkpList);
      // console.log(decMsg?.lkpList[0].lkpvalue);
      // console.log(decMsg?.lkpList[1].lkpvalue);

      AKey = decMsg?.lkpList[0].lkpvalue;
      SKey = decMsg?.lkpList[1].lkpvalue;


      AWS.config.update({
        accessKeyId: AKey,
        secretAccessKey: SKey,
        region: "ap-south-1",
      });
      this.s3 = new AWS.S3();


    setTimeout(() => {
      let logo = "datasheets/" + filename;

      // console.log(logo)
      const url = this.s3.getSignedUrl("getObject", {
        Bucket: environment.Bucket,
        Key: logo,
        Expires: 60,
      });
      this.pdfPath = url;
      // console.log(this.pdfPath)
      window.open(this.pdfPath, "_blank");
    }, 500);

  });
  }

  goto() {
    var htmlElement = document.getElementById('targetcontact');
    var elementPosition = htmlElement?.getBoundingClientRect().top || 0;
    window.scrollTo({
      top: elementPosition + window.pageYOffset - 100,
      behavior: 'smooth'
    })
  }
}
